import React, { useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  Box,
  Chip,
  MenuItem,
  ListSubheader,
  IconButton,
  Collapse,
} from "@material-ui/core";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  toggleButtonGroup: {
    marginLeft: theme.spacing(1),
  },
  toggleButton: {
    color: theme.palette.text.secondary,
    "&.Mui-selected": {
      backgroundColor: "rgba(33, 150, 243, 0.1)",
      color: "#2196f3",
      "&:hover": {
        backgroundColor: "rgba(33, 150, 243, 0.2)",
      },
    },
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
  hideIcon: {
    "& .MuiSelect-icon": {
      display: "none",
    },
  },
}));

const GroupSelect = ({
  aValue,
  setAValue,
  includeExclude,
  handleChangeInclude,
  groupesDestinataires,
  setListeGroupeDestinataireText,
}) => {
  const [openSubmenus, setOpenSubmenus] = useState({});
  const [openSelectGroupes, setOpenSelectGroupes] = useState(false);
  const [alignment, setAlignment] = useState(includeExclude);
  const classes = useStyles();

  const handleAlignment = (event, newAlignment) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
      handleChangeInclude(newAlignment);
    }
  };

  const handleDelete = (valueToDelete, text) => {
    setAValue((prev) => prev.filter((value) => value !== valueToDelete));

    setListeGroupeDestinataireText((prev) => {
      return prev.filter((v) => v !== text);
    });
  };

  const toggleSubmenu = (text) => {
    setOpenSubmenus((prev) => ({
      ...prev,
      [text]: !prev[text],
    }));
  };

  const handleMenuItemClick = (value) => {
    setAValue((prev) => {
      const newValue = prev.includes(value)
        ? prev.filter((v) => v !== value)
        : [...prev, value];

      return newValue;
    });
  };

  const handleSetGroupeDestinataireText = (value) => {
    setListeGroupeDestinataireText((prev) => {
      const newValue = prev.includes(value.Nom)
        ? prev.filter((v) => v !== value.Nom)
        : [...prev, value.Nom];

      return newValue;
    });
  };

  const handleCloseSelectGroupes = () => {
    setOpenSelectGroupes(false);
  };

  const handleOpenSelectGroupes = () => {
    setOpenSelectGroupes(true);
  };

  return (
    <FormControl variant="outlined" fullWidth>
      <InputLabel shrink={aValue.length > 0}>Groupes</InputLabel>
      <Select
        className={classes.hideIcon}
        label="Groupes"
        multiple
        value={aValue}
        onClose={handleCloseSelectGroupes}
        onOpen={handleOpenSelectGroupes}
        open={openSelectGroupes}
        onChange={(e) => {
          const selectedValues = e.target.value || [];
          setAValue(selectedValues);
        }}
        input={
          <OutlinedInput
            notched={aValue.length > 0}
            labelWidth={70}
            endAdornment={
              <ToggleButtonGroup
                value={alignment}
                exclusive
                onChange={handleAlignment}
                size="small"
                className={classes.toggleButtonGroup}
              >
                <ToggleButton value="include" className={classes.toggleButton}>
                  Inclure
                </ToggleButton>
                <ToggleButton value="exclude" className={classes.toggleButton}>
                  Exclure
                </ToggleButton>
              </ToggleButtonGroup>
            }
          />
        }
        renderValue={(selected) => (
          <Box display="flex" flexWrap="wrap" gap={0.5}>
            {selected.map((value) => {
              const selectedItem = groupesDestinataires.Destinataires.flatMap(
                (g) => g.children || []
              ).find((child) => child.id === value);
              return (
                <Chip
                  key={value}
                  label={selectedItem ? selectedItem.text : value}
                  onDelete={() => handleDelete(value, selectedItem.text)}
                  onMouseDown={(event) => event.stopPropagation()}
                  style={{
                    margin: "2px",
                  }}
                />
              );
            })}
          </Box>
        )}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 400,

              boxSizing: "border-box",
            },
          },
          getContentAnchorEl: null,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
        }}
      >
        {groupesDestinataires.Destinataires.map((groupe, id) => (
          <div key={`groupe-${id}-${groupe.text}`}>
            <ListSubheader
              style={{
                background: "none",
                fontWeight: "bold",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
              }}
              onMouseDown={(event) => event.preventDefault()}
              onClick={(event) => {
                event.stopPropagation();
                toggleSubmenu(`${groupe.text}-${id}`);
              }}
            >
              {groupe.text}
              <IconButton
                size="small"
                onMouseDown={(event) => event.preventDefault()}
                onClick={(event) => {
                  event.stopPropagation();
                  toggleSubmenu(`${groupe.text}-${id}`);
                }}
              >
                {openSubmenus[`${groupe.text}-${id}`] ? (
                  <ExpandLessIcon />
                ) : (
                  <ExpandMoreIcon />
                )}
              </IconButton>
            </ListSubheader>
            <Collapse
              in={openSubmenus[`${groupe.text}-${id}`]}
              timeout="auto"
              unmountOnExit
            >
              {(groupe.children || []).map((child, childIndex) => (
                <MenuItem
                  key={`child-${id}-${child.id}-${childIndex}`}
                  value={child.id}
                  onClick={(event) => {
                    event.stopPropagation();
                    handleMenuItemClick(child.id);
                    handleSetGroupeDestinataireText(child);
                    handleCloseSelectGroupes();
                  }}
                >
                  {child.text}
                </MenuItem>
              ))}
            </Collapse>
          </div>
        ))}
      </Select>
    </FormControl>
  );
};

export default GroupSelect;
